import { Placement } from '@floating-ui/react'
import clsx from 'clsx'
import { Contract, isMultiCpmm } from 'common/contract'
import { getPerpBackingPool } from 'common/perps/amm'
import { formatWithToken } from 'common/util/format'

import { Tooltip } from '../widgets/tooltip'
import { BsDroplet, BsDropletFill, BsDropletHalf } from 'react-icons/bs'
import {
  getTierIndexFromLiquidity,
  getTierIndexFromLiquidityAndAnswers,
} from 'common/tier'

export function LiquidityTooltip(props: {
  contract: Contract
  className?: string
  placement?: Placement
  iconClassName?: string
}) {
  const { contract, className, placement = 'bottom', iconClassName } = props
  const { mechanism } = contract

  const isCashContract = contract.token === 'CASH'
  const isPerp = contract.mechanism === 'perp'
  const hasAnswers = isMultiCpmm(contract)
  const totalLiquidity = isPerp
    ? getPerpBackingPool(contract.poolLong, contract.poolShort)
    : 'totalLiquidity' in contract
    ? contract.totalLiquidity
    : 0
  const liquidityTier = hasAnswers
    ? getTierIndexFromLiquidityAndAnswers(
        totalLiquidity,
        contract.answers.length
      ) - 1
    : getTierIndexFromLiquidity(totalLiquidity)
  if (!isMultiCpmm(contract) && mechanism !== 'cpmm-1' && mechanism !== 'perp')
    return <></>
  const amount = totalLiquidity
  return (
    <Tooltip
      text={`${formatWithToken({
        amount,
        token: isCashContract ? 'CASH' : 'M$',
      })} in ${isPerp ? 'current backing pools' : 'liquidity subsidies'} ${
        hasAnswers
          ? `(per answer: ${formatWithToken({
              amount: amount / contract.answers.length,
              token: isCashContract ? 'CASH' : 'M$',
              short: true,
            })})`
          : ''
      }`}
      placement={placement}
      className={clsx('flex flex-row items-center gap-0.5', className)}
      tooltipClassName="z-40"
    >
      {liquidityTier < 1 ? (
        <BsDroplet className={iconClassName} />
      ) : liquidityTier < 2 ? (
        <BsDropletHalf className={iconClassName} />
      ) : (
        <BsDropletFill className={iconClassName} />
      )}
      {formatWithToken({
        amount,
        token: isCashContract ? 'CASH' : 'M$',
        short: true,
      })}
    </Tooltip>
  )
}
